import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { Avatar } from '@components/basics/Images/Avatar';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import type { FragmentType } from '@graphql/reactQuery';
import { CollectorCardUserInfoFragmentDoc, getFragment } from '@graphql/reactQuery';
import { SPACE } from '@utils/constants';
import { getSingularOrPlural } from '@utils/helpers';
import { webappUriPath } from '@utils/url';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment CollectorCardUserInfo on User {
    id
    username
    publicAddress
    webappUri
    avatar {
      id
      url
    }
  }
`);

const AVATAR_SIZE = 24;
export const CollectorUser = ({
  collectorUserFrag,
  editionsMinted,
}: {
  collectorUserFrag: FragmentType<CollectorCardUserInfoFragmentDoc>;
  editionsMinted: number;
}) => {
  const { avatar, username, publicAddress, webappUri } = getFragment(
    CollectorCardUserInfoFragmentDoc,
    collectorUserFrag,
  );
  return (
    <div className="mt-1 flex h-10 w-full items-start md:mt-0">
      <div className="flex w-full items-center gap-2 px-[10px]">
        <Avatar
          src={avatar?.url}
          size={AVATAR_SIZE}
          username={username}
          walletAddress={publicAddress}
          webappUri={webappUri}
          borderRadius="50%"
          hasShadow
          hasDarkBorder
        />
        <div className="flex overflow-hidden whitespace-nowrap text-base-xs">
          <AccessibleLink pathnameUri={webappUriPath(webappUri)} className="overflow-hidden">
            <p className="overflow-hidden text-ellipsis whitespace-nowrap font-semibold text-base200 hover:text-white">
              {username}
            </p>
          </AccessibleLink>
          {SPACE}
          <p className="text-base400">
            minted {editionsMinted}
            {SPACE}
            {getSingularOrPlural({
              word: 'edition',
              count: editionsMinted,
            })}
          </p>
        </div>
      </div>
    </div>
  );
};
